import React from "react";
import { Text, useMantineTheme, Box } from '@mantine/core';

const InputWrapperCustom = ({
    children,
    stateLabel = '',
    stateLabelFullWidth = false,
    stateWithAsterisk = false,
    stateMT = '0',
    stateMB = '0',
    stateError = '',
    stateErrorMT = '.35rem',
    stateErrorSX = {},
    stateDescription = ''
}) => {

    const theme = useMantineTheme();

    return (
        <Box
            mt={stateMT}
            mb={stateMB}
        >
            <Box
                sx={{ display: 'flex' }}
                mb='.25rem'
            >
                <Text
                    fw={500}
                    size={theme.fontSizes.sm}
                    c={theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.dark[0]}
                    sx={
                        stateLabelFullWidth ? { width: '100%' } : {}
                    }
                >
                    {stateLabel}
                </Text>

                {stateWithAsterisk &&
                    <Text
                        c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[8]}
                        size={theme.fontSizes.sm}
                    >
                        &nbsp;*
                    </Text>
                }
            </Box>

            {stateDescription &&
                <Text
                    c={theme.colorScheme === 'light' ? theme.colors.gray[6] : theme.colors.dark[2]}
                    size={theme.fontSizes.xs}
                    mt='.25rem'
                    mb='.5rem'
                >
                    {stateDescription}
                </Text>
            }

            {children}

            {stateError &&
                <Text
                    c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[8]}
                    size={theme.fontSizes.xs}
                    mt={stateErrorMT}
                    sx={stateErrorSX}
                >
                    {stateError}
                </Text>
            }
        </Box>
    )
}

export default React.memo(InputWrapperCustom);